<template>
  <div style="padding:20px;">
    <h3 style="margin-bottom:16px;">销售余额查询</h3>

    <!-- 查询区域 -->
    <div style="margin-bottom:16px;">
      <el-input
        v-model="inputName"
        placeholder="请输入运营账户名称，如：baozongAI"
        style="width:360px;"
        clearable
        @keyup.enter.native="doQuery"
      ></el-input>
      <el-button
        type="primary"
        :loading="queryLoading"
        @click="doQuery"
        style="margin-left:12px;"
      >查询</el-button>
      <span style="margin-left:12px;font-size:12px;color:#909399;">
        输入完整名称后点击查询，匹配失败提示暂无数据
      </span>
    </div>

    <!-- 初始化提示 -->
    <div v-if="pageLoading" style="margin:15px 0;color:#409EFF;">
      正在初始化，获取账户数据中...
    </div>

    <!-- 合计卡片 -->
    <div v-if="resultVisible" style="margin-bottom:16px;display:flex;gap:16px;flex-wrap:wrap;">
      <div style="background:#ecf5ff;border:1px solid #d9ecff;border-radius:6px;padding:20px 24px;min-width:240px;">
        <div style="font-size:14px;color:#5e6b82;margin-bottom:8px;">总现金余额</div>
        <div style="font-size:28px;font-weight:bold;color:#3173b3;font-family:'Courier New',monospace;">
          ¥ {{ formatCurrency(totalCashBalance) }}
        </div>
      </div>
      <div style="background:#f0f9eb;border:1px solid #e1f3d8;border-radius:6px;padding:20px 24px;min-width:240px;">
        <div style="font-size:14px;color:#5e6b82;margin-bottom:8px;">今日消耗合计</div>
        <div style="font-size:28px;font-weight:bold;color:#67c23a;font-family:'Courier New',monospace;">
          ¥ {{ formatCurrency(totalTodayConsumeAmount) }}
        </div>
      </div>
      <div style="background:#fdf6ec;border:1px solid #faecd8;border-radius:6px;padding:20px 24px;min-width:240px;">
        <div style="font-size:14px;color:#5e6b82;margin-bottom:8px;">昨日消耗合计</div>
        <div style="font-size:28px;font-weight:bold;color:#e6a23c;font-family:'Courier New',monospace;">
          ¥ {{ formatCurrency(totalYesterdayConsumeAmount) }}
        </div>
      </div>
    </div>

    <!-- 子账户表格 -->
    <div v-if="resultVisible">
      <el-table
        :data="sortedSubAccountList"
        border
        style="width:100%;"
        v-loading="tableLoading"
        empty-text="暂无子账户数据"
        @sort-change="handleSortChange"
        :default-sort="{prop: 'cashBalance', order: 'descending'}"
      >
        <el-table-column prop="name" label="子账户名称" min-width="140"></el-table-column>
        <el-table-column prop="belongSubRemark" label="账号备注" min-width="140"></el-table-column>
        <el-table-column prop="todayConsumeAmount" label="今日消耗" min-width="120" align="right" sortable="custom">
          <template slot-scope="scope">
            ¥ {{ formatCurrency(scope.row.todayConsumeAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="yesterdayConsumeAmount" label="昨日消耗" min-width="120" align="right" sortable="custom">
          <template slot-scope="scope">
            ¥ {{ formatCurrency(scope.row.yesterdayConsumeAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="cashBalance" label="现金余额" min-width="120" align="right" sortable="custom">
          <template slot-scope="scope">
            ¥ {{ formatCurrency(scope.row.cashBalance) }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";

const BASE = "https://control.zjwec.cn";

export default {
  data: function () {
    return {
      cookie: "",
      accountList: [],
      inputName: "",
      totalCashBalance: "0.00",
      totalTodayConsumeAmount: "0.00",
      totalYesterdayConsumeAmount: "0.00",
      subAccountList: [],
      pageLoading: false,
      queryLoading: false,
      tableLoading: false,
      resultVisible: false,
      sortProp: "",
      sortOrder: ""
    };
  },
  computed: {
    sortedSubAccountList: function () {
      var list = this.subAccountList.slice();
      var prop = this.sortProp;
      var order = this.sortOrder;
      if (!prop || !order) return list;
      return list.sort(function (a, b) {
        var va = parseFloat(a[prop]) || 0;
        var vb = parseFloat(b[prop]) || 0;
        return order === "ascending" ? va - vb : vb - va;
      });
    }
  },
  created: function () {
    this.initPage();
  },
  methods: {
    // 格式化货币
    formatCurrency: function (value) {
      if (!value && value !== 0) return "0.00";
      var num = parseFloat(value);
      if (isNaN(num)) return value;
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    // 排序变化
    handleSortChange: function (sort) {
      this.sortProp = sort.prop;
      this.sortOrder = sort.order;
    },

    // 页面初始化：获取cookie，再获取运营账户列表
    initPage: function () {
      var that = this;
      that.pageLoading = true;

      // 接口1：根据二代名称获取cookie
      axios
        .get(BASE + "/api/v1/vivo/second/cookie/getByName", {
          params: { name: "宁波" }
        })
        .then(function (resp) {
          var data = resp.data;
          if (data.code == 0 && data.data && data.data.cookie) {
            that.cookie = data.data.cookie;

            // 接口2：用cookie获取运营账户列表
            var encodedCookie = encodeURIComponent(that.cookie);
            return axios.get(
              BASE + "/api/v1/vivo/second/account/relatedList?cookie=" + encodedCookie
            );
          } else {
            that.$message.error("获取cookie失败：" + (data.msg || "未知错误"));
            that.pageLoading = false;
            return Promise.reject("no_cookie");
          }
        })
        .then(function (resp) {
          var data = resp.data;
          if (data.code == 0 && Array.isArray(data.data)) {
            that.accountList = data.data;
          } else {
            that.$message.error("获取运营账户列表失败：" + (data.msg || "未知错误"));
          }
          that.pageLoading = false;
        })
        .catch(function (err) {
          if (err !== "no_cookie") {
            that.$message.error("初始化失败，请检查网络连接");
          }
          that.pageLoading = false;
        });
    },

    // 查询匹配
    doQuery: function () {
      var that = this;
      var name = that.inputName.trim();

      if (!name) {
        that.$message.warning("请输入运营账户名称");
        return;
      }

      if (!that.accountList.length) {
        that.$message.warning("运营账户列表尚未加载完成，请稍候");
        return;
      }

      // 精确匹配
      var matched = null;
      for (var i = 0; i < that.accountList.length; i++) {
        if (that.accountList[i].subAccountName === name) {
          matched = that.accountList[i];
          break;
        }
      }

      if (!matched) {
        that.$message.warning("暂无此运营账户数据");
        return;
      }

      // 匹配成功，查询子账户
      that.queryLoading = true;
      that.tableLoading = true;
      that.resultVisible = true;
      that.subAccountList = [];

      var encodedCookie = encodeURIComponent(that.cookie);
      axios
        .get(
          BASE + "/api/v1/vivo/second/account/subList?cookie=" + encodedCookie + "&subAccountId=" + matched.id
        )
        .then(function (resp) {
          var data = resp.data;
          if (data.code == 0 && data.data) {
            that.subAccountList = data.data.list || [];
            that.totalCashBalance = data.data.totalCashBalance || "0.00";
            that.totalTodayConsumeAmount = data.data.totalTodayConsumeAmount || "0.00";
            that.totalYesterdayConsumeAmount = data.data.totalYesterdayConsumeAmount || "0.00";
          } else {
            that.$message.error("查询子账户失败：" + (data.msg || "未知错误"));
          }
          that.queryLoading = false;
          that.tableLoading = false;
        })
        .catch(function () {
          that.$message.error("查询子账户失败，请检查网络连接");
          that.queryLoading = false;
          that.tableLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.el-table :deep(.el-table__header-wrapper) th {
  background-color: #f0f2f5;
  font-weight: 600;
  color: #303133;
}
</style>



// WEBPACK FOOTER //
// src/components/vivo/secondAccountQuery.vue